import { __decorate } from "tslib";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TotalCostsComponent } from './total-costs.component';
import { SharedModule } from '../../shared';
var TotalCostsModule = /*@__PURE__*/ (function () {
    function TotalCostsModule() {
    }
    return TotalCostsModule;
}());
export { TotalCostsModule };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/modules/total-costs/total-costs.module.ts
// module id = null
// module chunks = 